const translation = {
	common: {
		addToList: "Додати в список",
		confirmAction: "Підтвердьте дію!",
		confirmed: "Підтверджено",
		done: "Готово",
		save: "Зберегти",
		cancel: "Скасувати",
	},
	validation: {
		required: "Це поле є обов'язковим для заповнення",
	},
	months: {
		january: "Січня",
		february: "Лютого",
		march: "Березня",
		april: "Квітня",
		may: "Травня",
		june: "Червня",
		july: "Липня",
		august: "Серпня",
		september: "Вересня",
		october: "Жовтня",
		november: "Листопада",
		december: "Грудня",
	},
	banners: {
		addBanner: "Додати банер",
		addLargeBanner: "Додати великий банер",
		bannerLink: "Посилання на банер",
		confirmDelete: "Хочете видалити банер?",
		confirmSaveBanners: "Ви підтверджуєте збереження банерів?",
		confirmSaveChanges: "Ви підтверджуєте збереження змін?",
		confirmSaveText: "Підтвердьте збереження тексту",
		description: "Опис",
		displayBanner: "Показувати банер",
		editBanner: "Редагувати банер",
		imageAlt: "Виберіть зображення",
		noBanners: "Поки немає банерів",
		photoDeleted: "Фото {{name}} було видалено!",
		recommendedLargeSize:
			"Рекомендований розмір фото для банера 1600x600 (розширення файлу jpg, jpeg, png)",
		title: "Назва",
		errors: {
			invalidUploadData: "Некоректні дані логіна або назви зображення",
			largeFileName: "Вибране зображення має занадто довгу назву",
			maxFileSize: "Розмір фото не більше 0.5 МБ",
			maxResolution: "Максимальна роздільна здатність зображення 1920px x 1280px",
			requiredBanner: "Обов'язково завантажте банер",
			requiredTwoBanners: "Обов'язково завантажте два банери",
			supportedTypes: "Підтримувані розширення зображень: jpg, jpeg, png",
			uploadImage: "Помилка завантаження зображення",
		},
		placeholders: {
			description: "Введіть опис банера",
			title: "Введіть назву банера",
		},
	},
	discountProducts: {
		categoriesTitle: "Категорії, на які не застосовуються знижки",
		confirmSave: "Ви підтверджуєте збереження категорій і товарів?",
		duplicateId: "Цей ID вже є у списку",
		emptyField: "Порожнє поле",
		productsTitle: "Продукти, на які не застосовуються знижки",
		placeholders: {
			categoryId: "Введіть ID категорії",
			productId: "Введіть ID товару",
		},
	},
	discounts: {
		deliveryOrder: "На доставку",
		discounts: "Знижки",
		firstOrder: "Перше замовлення",
		loyaltySystem: "Система лояльності",
		pickupOrder: "На самовивіз",
		sales: "Акції",
		tabs: {
			banners: "Банери",
			discounts: "Знижки",
			promocodes: "Промокоди",
			sales: "Акції",
		},
		form: {
			amount: "Сума",
			amountDiscount: "Сума знижки",
			amountDiscountPlaceholder: "Введіть суму знижки",
			confirmSaveChanges: "Ви підтверджуєте збереження змін?",
			discount: "Знижка",
			discountPercent: "Відсоток знижки",
			discountPercentPlaceholder: "Введіть відсоток знижки",
			integerOnly: "Лише цілі числа",
			maxPercent: "Значення повинно бути менше або дорівнювати {count}",
			orderAmount: "Введіть суму замовлення",
			present: "Подарунок",
			productId: "ID товару",
			productIdPlaceholder: "Введіть ID товару",
			required: "Це обов'язкове поле",
		},
	},
	promocodes: {
		add: "Додати",
		apply: "Застосувати",
		applyForDiscountProducts: "Застосовувати для акційних товарів",
		calendarPeriod: "Обрати період:",
		categoriesExcluded: "Категорії, на які не застосовується промокод",
		categoriesExcludedHint: "Список категорій, на які не застосовується промокод",
		code: "Код промокоду",
		codePlaceholder: "Введіть код промоакції",
		confirmDelete: "Ви підтверджуєте видалення {{id}}?",
		create: "Створити промокод",
		description: "Опис",
		descriptionPlaceholder: "Введіть опис промоакції",
		discountSystemId: "ID знижки з системи обліку",
		discountSystemIdNote:
			"Заповнюйте лише якщо точно впевнені, що ID правильний (для iiko приклад 0a124f13-99b2-41df-b286-4f21e41c4717, для poster 4)",
		duplicateId: "Цей ID вже є у списку",
		edit: "Редагувати промокод",
		emptyField: "Порожнє поле",
		invalidData: "Некоректні дані",
		latinOnly: "Тільки латинські літери",
		minOrderAmount: "Мінімальна сума замовлення",
		minOrderAmountHint:
			"Мінімальна сума замовлення для використання промокоду. Якщо така відсутня, вкажіть 0",
		minOrderAmountPlaceholder: "Введіть мінімальну суму або 0",
		noPromocodes: "Поки ще немає промокодів",
		productsExcluded: "Продукти, на які не застосовується промокод",
		productsExcludedHint: "Список продуктів, на які не застосовується промокод",
		title: "Промокоди",
		titleField: "Назва",
		titlePlaceholder: "Введіть назву промоакції",
	},
	categoryForPickup: {
		categoriesTitle: "Категорії",
		duplicateId: "Цей ID вже є у списку",
		fetchError: "Помилка під час отримання даних:",
		placeholder: "Введіть ID категорії",
		saveError: "Помилка під час збереження даних:",
		saveSuccess: "Дані успішно збережено",
		saveSuccessMessage: "Дані успішно збережено!",
		stopList: "Стоп-лист",
		tooltip: "Введіть ID категорії, яку хочете приховати",
	},
	blackList: {
		addDuplicate: "Такий номер вже є",
		emptyValue: "Введіть значення",
		menuTitle: "Меню",
		numbersTitle: "Номери",
		phonePlaceholder: "Введіть номер",
		saveError: "Не вдалося оновити чорний список:",
		saveSuccessMessage: "Дані успішно збережено!",
		textPlaceholder: "Введіть текст для зміни",
		textTitle: "Текст для чорного списку",
	},
	disableAlert: {
		messageStatus: "Стан повідомлення",
		messageText: "Текст повідомлення",
		placeholder: "Ваш текст",
		switchLabel: "Увімкнути повідомлення",
		updateError: "Помилка під час оновлення даних:",
	},
	disableApp: {
		messageText: "Текст повідомлення",
		onApp: "Увімкнути прийом замовлень",
		onDelivery: "Увімкнути доставку",
		onPickup: "Увімкнути самовивіз",
		placeholder: "Ваш текст",
		title: "Стан замовлень",
	},
	delivery: {
		add: "Додати",
		addZone: "Додати зону",
		confirmCreateZone: "Ви підтверджуєте створення зони?",
		confirmDeleteZone: "Ви підтверджуєте видалення зони {{name}}?",
		confirmEditZone: "Ви підтверджуєте редагування зони?",
		confirmSaveChanges: "Ви підтверджуєте збереження змін",
		deliveryCost: "Вартість доставки",
		deliveryItemId: "ID товару доставки",
		editZone: "Редагувати зону",
		freeDelivery: "Безкоштовна доставка",
		freeDeliveryFrom: "Безкоштовна доставка від",
		minDeliveryAmount: "Мінімальна сума для доставки",
		noZones: "Поки немає створених зон",
		title: "Умова доставки",
		zoneName: "Назва зони",
		zones: "Зони",
		placeholders: {
			deliveryCost: "Введіть вартість доставки",
			deliveryItemId: "Введіть ID товару доставки",
			freeDeliveryFrom: "Введіть суму мін. доставки",
			minDeliveryAmount: "Введіть суму мін. замовлення",
			zoneName: "Введіть назву зони",
		},
		validation: {
			deliveryCost: "Введіть вартість доставки",
			deliveryItemId: "Введіть ID товару доставки",
			freeDeliveryFrom: "Введіть безкоштовну доставку",
			minDeliveryAmount: "Введіть суму замовлення",
			zoneName: "Введіть назву",
		},
	},
	deliveryZonesControl: {
		enableZone: "Увімкнути доставку у зоні",
		error: "Щось пішло не так, спробуйте ще раз",
		minActiveZone: "Мінімум одна зона повинна бути активна",
		title: "Контроль зон доставки",
	},
	labels: {
		add: "Додати",
		addLabel: "Додати лейбл",
		addNewLabel: "Додати новий лейбл",
		addProductId: "Додати ID товару",
		backgroundColor: "Колір фону",
		banner: "Банер",
		bannerPreview: "Прев'ю банера",
		bannerText: "Текст банера",
		delete: "Видалити",
		editLabel: "Редагувати лейбл",
		imageReady: "Зображення готове до завантаження",
		imageRequired: "Зображення обов'язкове",
		labels: "Лейби",
		noLabels: "Немає наявних лейбів",
		noText: "Без тексту",
		position: "Позиція",
		text: "Текст",
		textColor: "Колір тексту",
		textRequired: "Введіть текст банера",
		uploadBanner: "Завантаження банера",
		uploadImage: "Завантажити зображення",
		errors: {
			deleteImage: "Помилка під час видалення зображення",
			fileTooLarge: "Файл занадто великий. Максимальний розмір - 500KB.",
			imageName: "Помилка під час отримання імені зображення з сервера",
			missingFileOrLogin: "file або login не передані",
			unsupportedFormat: "Непідтримуваний формат файлу. Дозволено: JPG, JPEG, PNG.",
			uploadImage: "Помилка під час завантаження зображення.",
		},
	},
	loadControl: {
		confirmSaveChanges: "Ви підтверджуєте збереження змін?",
		deliveryInterval: "Інтервал часу для доставки (хв)",
		minNumber: "Введіть число більше або дорівнює 5",
		pickupInterval: "Інтервал часу для самовивозу (хв)",
		title: "Контроль навантаження",
	},
	menu: {
		categories: "Категорії",
		categoryIdPlaceholder: "Введіть ID категорії",
		duplicateId: "Цей ID вже є у списку",
		menu: "Меню",
		products: "Товари",
		productIdPlaceholder: "Введіть ID товару",
		saveSuccess: "Дані успішно збережено!",
	},
	menuSort: {
		categories: "Категорії",
		confirmSortChange: "Хочете змінити сортування товарів?",
		copied: "Скопійовано",
		copyId: "Копіювати ID",
		products: "Товари",
		title: "Сортування меню",
	},
	payCard: {
		cardPaymentSystem: "Система оплати карткою",
		confirmSaveChanges: "Ви підтверджуєте збереження змін?",
		title: "Системи оплати",
		placeholders: {
			merchant: "Введіть Merchant",
			merchantDomain: "Введіть merchantDomain",
			merchantLogin: "Введіть Merchant login",
			merchantSecretKey: "Введіть Merchant secret key",
			mobileSdkKey: "Введіть Mobile Sdk Key",
			payeeId: "Введіть PayeeId",
			privateKey: "Введіть Private key",
			publicKey: "Введіть Public key",
			secretKey: "Введіть Secret key",
			shopId: "Введіть shop id",
			yandexMoney: "Введіть Yandex Money",
		},
	},
	pickupControl: {
		enablePickupAt: "Увімкнути самовивіз на",
		error: "Щось пішло не так, спробуйте ще раз",
		minActiveTerminal: "Мінімум один термінал повинен бути активний",
		title: "Контроль точок самовивозу",
	},
	products: {
		add: "Додати",
		addCategory: "Додати категорію",
		addProduct: "Додати товар",
		addProductFirst: "Спочатку додайте товар {{language}} мовою",
		category: "Категорія",
		chooseCategory: "Виберіть категорію",
		chooseCity: "Виберіть місто зі списку",
		chooseTerminal: "Вибір закладу",
		confirmSortChange: "Хочете змінити сортування товарів?",
		copy: "Копіювати",
		copied: "Скопійовано",
		copyCategoryId: "Копіювати ID категорії {{id}}",
		delete: "Видалити",
		deleteCategoryConfirm: "Ви хочете видалити категорію {{name}}?",
		deleteCategoryProductsConfirm:
			"Під час видалення категорії буде видалено всі товари! Видалити?",
		deleteProductConfirm: "Ви хочете видалити товар {{name}}?",
		description: "Опис",
		display: "Відображати",
		differentPrices: "Різні ціни у закладах",
		edit: "Редагувати",
		editCategory: "Редагувати категорію",
		errorTryAgain: "Помилка, спробуйте ще раз!",
		hide: "Сховати",
		integerOnly: "Підтримуються лише цілі числа",
		maxPhotoSize: "Розмір фото не більше 0.5 МБ",
		menuLanguage: "Мова меню",
		name: "Назва",
		nameField: "Найменування",
		newPhoto: "Нове фото",
		noCategories: "Категорій поки що немає",
		noDescription: "Опис відсутній",
		noAccess: "У вас немає доступу",
		photo: "Фото",
		price: "Ціна",
		saveError: "Сталася помилка, спробуйте ще",
		shop: "Заклад:",
		showMore: "Показати більше",
		sortMode: "Режим сортування",
		unsupportedImageFormat: "Цей формат зображення не підтримується",
	},
	promotion: {
		advertisingText:
			"Окрім реклами застосунку на власному сайті, ви можете дати прямі посилання на застосунок у ваших групах у соціальних мережах: instagram, vk, facebook.",
		advertisingTitle: "Як ще прорекламувати застосунок?",
		copy: "Скопіювати",
		copied: "Текст було успішно скопійовано!",
		downloadQr: "Завантажити QR код",
		enableStoreBadges: "Увімкнути значки AppStore & Google Play",
		insertCodeTitle: "Код для вставки сайту",
		qrDoorSize: "Вхідні двері - 20 см по довгій стороні.",
		qrMenuSize: "Обкладинка меню - 5 см по довгій стороні.",
		qrParagraph1:
			"Якщо навести ввімкнену камеру телефона на QR-код, система запропонує перейти за посиланням і завантажити мобільний застосунок. Це найшвидший спосіб знайти застосунок в AppStore або Google Play.",
		qrParagraph2:
			"Наклейку можна розмістити на вході до закладу, на обкладинці меню, на стійках столів або в будь-якому іншому помітному місці. Наклейка виглядає сучасно і значно підвищує кількість завантажень застосунку.",
		qrParagraph3:
			"Формат, який ми пропонуємо для завантаження, підійде для будь-якої типографії або студії друку. Просто передайте посилання типографії і замовте потрібний обсяг наклейок.",
		qrRecommendedSizes: "Рекомендовані розміри:",
		qrStickerTitle: "QR-код для наклейки",
		scriptPlacement:
			"Цей скрипт потрібно вставити на сайт між тегами <head></head>.",
		scriptVisitors:
			"Усі відвідувачі сайту побачать, що у вас з'явився мобільний застосунок.",
		title: "Просування",
	},
	push: {
		allUsers: "Надіслати всім",
		audience: "Аудиторія",
		city: "Місто",
		confirmSend: "Ви підтверджуєте надсилання push-повідомлення?",
		favorite: "Вибрані",
		favorites: "Вибрані",
		hiddenText: "Прихований текст",
		invalidPhone: "Невалідний номер телефону",
		maxPhoneLength: "Максимальна довжина номера - 14 цифр, поточна - {{count}} цифр",
		messagePlaceholder: "Введіть текст повідомлення",
		minPhoneLength: "Мінімальна довжина номера - 11 цифр, поточна - {{count}} цифр",
		phoneFormat: "Номер у форматі:",
		phonePlaceholder: "Номер телефону",
		phoneRequired: "Введіть номер телефону",
		productLink: "З переходом на товар",
		productPlaceholder: "Введіть id товару",
		send: "Надіслати",
		sendError: "Під час надсилання сталася помилка, спробуйте ще раз!",
		sendSuccess: "Ваше повідомлення успішно надіслано!",
		title: "Надіслати Push-повідомлення",
		text: "Текст",
		ukrainePhone: "Україна: 380501234567",
		russiaPhone: "Росія: 79201234567",
		usersHint:
			"Додайте номери телефонів, щоб надіслати повідомлення конкретним користувачам, або залиште список порожнім, якщо хочете надіслати push-повідомлення всім користувачам.",
		usersList: "Список користувачів:",
		validation: {
			cityRequired: "Необхідно вибрати місто",
		},
		selectCity: "Виберіть місто",
	},
	reviews: {
		callCenter: "Робота Call-центру:",
		comment: "Коментар:",
		date: "Дата:",
		day: "День",
		deliveryQuality: "Якість доставки:",
		highGrade: "Найвища оцінка",
		impression: "Загальне враження:",
		loadMore: "Показати ще",
		loadMoreDays: "Показати ще 7 днів",
		lowGrade: "Найнижча оцінка",
		month: "Місяць",
		newest: "Найновіші",
		noReviews: "У вас ще немає відгуків!",
		oldest: "Найстаріші",
		period: "Період:",
		phone: "Номер телефону:",
		productQuality: "Якість товару:",
		sort: "Сортувати",
		sortWithColon: "Сортувати:",
		title: "Відгуки",
		week: "Тиждень",
		impressions: {
			negative: "негативне 🤬",
			neutral: "нейтральне 😐",
			positive: "позитивне 😍",
		},
	},
	workTime: {
		confirmSaveChanges: "Ви підтверджуєте збереження змін",
		deliveryInterval: "Інтервал часу для доставки (хв)",
		infoMessage: "Інформаційне повідомлення",
		maxTime: "Максимальний час",
		maxWorkTime: "Максимальний час роботи закладу",
		messagePlaceholder: "Введіть текст...",
		minEstablishment: "Мінімальний час закладу",
		minTime: "Мінімальний час",
		pickupInterval: "Інтервал часу для самовивозу (хв)",
		title: "Час роботи",
	},
	defaultScreen: {
		logout: "Вийти",
		navigation: {
			addProduct: "Додати товар",
			blacklist: "Чорний список",
			cardPayment: "Оплата карткою",
			categories: "Категорії",
			deliveryTerms: "Умови доставки",
			deliveryZones: "Зони доставки",
			disableOrders: "Відключити замовлення",
			disablePickup: "Відключити самовивіз",
			editProduct: "Редагувати товар",
			labels: "Лейби",
			leaveDescription: "Ваші дані не буде збережено.",
			leaveTitle: "Ви хочете піти?",
			loadControl: "Контроль навантаження",
			loginMessage: "Повідомлення при вході",
			loyaltySystem: "Система лояльності",
			menu: "Меню",
			menuFilling: "Заповнення меню",
			pickupCategories: "Категорії самовивозу",
			products: "Товари",
			promotion: "Просування",
			push: "Push-повідомлення",
			reviews: "Відгуки",
			settings: "Налаштування",
			sortMode: "Режим сортування",
			stopList: "Стоп-лист",
			stopListSorting: "Стоп-лист/сортування",
			workingHours: "Час роботи",
		},
	},
	language: {
		label: "Мова",
		en: "Анг",
		ru: "Рос",
		uk: "Укр",
	},
};

export default translation;
